<template>
    <transition name="slide-fade" >
        <div  id="academicsHolder" >
            <div class="uk-child-width-1-1" uk-grid>
                <div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
                    <div class="uk-container uk-container-small ">
                        <p class="uk-text-center uk-text-lead@l uk-text-large@l">
                            It doesn't matter where you have started we will help you get to the finish
                            <br>
                            <span class="uk-text-small uk-text-muted">
                  Late applications may be considered but will attract late fees.
                </span>
                        </p>
                    </div>
                </div>

                <div class="uk-padding  uk-margin-remove-top">
                    <h1 class="uk-heading-line uk-text-center specHeading"><span>Transfer Students</span></h1>
                    <div class="uk-container uk-container-small">


                        <div class="uk-child-width-1-1@m" uk-grid>
                            <div class="uk-align-center">
                                <img src="../assets/transfer.jpg" alt="">
                            </div>
                            <div class=" ">
                                <p>
                                    In order to be considered, transfer students must be in good social and academic standing at all institutions previously attended.
                                    Students who transfer from approved institutions of higher education, may have credits earned in those institutions accepted without
                                    validating examinations, by doing the following:
                                </p>
                                <ul class="uk-list uk-list-bullet">
                                    <li>Submitting complete transcripts from schools attended to admissions@ncu.edu.jm.
                                        Regular placement is dependent on evaluation of the transcript.
                                        Transcripts will not be regarded as valid unless they are sent by the registrars of the respective institutions directly to the Records Management Coordinator of Northern Caribbean University.
                                        Not more than 96 semester credit hours may be accepted toward a bachelor's degree or 32 semester credits toward an associate degree or a diploma
                                    </li>
                                    <li>Submitting course outlines if exemptions are desired</li>
                                    <li>A sound financial plan</li>
                                    <li>Meeting a grade of "C" on all transferable credits.
                                        For a credit to be accepted, it must be relevant to the student's particular programmes at Northern Caribbean University.
                                        An applicant's work may be summarized on one transcript, but transfer credits will not be accepted until an official transcript has
                                        been received from each institution.
                                    </li>
                                    <li>
                                        Meeting Northern Caribbean University entrance requirements if transferring with less than sophomore standing from an accredited or approved college/university</li>
                                </ul>

                                <p class="uk-text-muted ">
                                    <span class="uk-text-lead uk-text-danger">Please Note</span> <br>
                                    Transfer credits are regarded as provisional from the time of an applicant's admission until the completion of 16 credits,
                                    with at least a 2.5 GPA, and are applied to their permanent record at the time of graduation.

                                    If students request a transcript from Northern Caribbean University before they graduate, credits from institutions previously attended
                                    will not be listed on the transcript. After The Office of Recruitment and Admissions has received official transcripts,
                                    an assessment will be given to the students and to the relevant department chairpersons.


                                    Students applying from non-approved colleges/universities with a grade point average of at least 2.00 may be accepted on probation.
                                    Status will be regularized only after the completion of 16 credits with at least a 2.5 GPA.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="uk-padding uk-background-muted">
                    <div class="uk-container uk-container-small uk-padding-small">
                        <div uk-grid>

                            <div class="uk-width-1-1">
                                <h3 class="uk-heading-bullet uk-text-muted">Incomplete Applications</h3>
                                <p class="uk-text-small uk-text-muted">
                                    Applicants are reminded that if they were given provisional acceptance and have not yet fulfilled the requirements for acceptance into their programmes,
                                    which include meeting the standard for matriculation, be interviewed by their departments and submission of all outstanding documents, they will not be
                                    given a formal acceptance letter at the New Students’ Meeting.

                                    <br><br>
                                    If you have any questions concerning your admissions process, please feel free to call us at the office at:
                                    <br><br>
                                    Phone: 1-876-963-7250-7
                                    <br><br>
                                    For more information contact admissions@ncu.edu.jm
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </transition>
</template>

<script>
    export default {
        name: "transferstudent",
        mounted(){
            window.scrollTo(0, 0);
        },
        metaInfo: {
            // Children can override the title.
            title: 'NCU Transfer Students Admission Requirements',
            // Result: My Page Title ← My Site
            // If a child changes the title to "My Other Page Title",
            // it will become: My Other Page Title ← My Site
            //titleTemplate: '%s ← My Site',
            // Define meta tags here.
            meta: [
                {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
                {name: 'viewport', content: 'width=device-width, initial-scale=1'},
                {name: 'description', content: 'Transfer Students admission requirements at Northern Caribbean University '}
            ]
        }
    }
</script>

<style scoped>

</style>
